module.exports = "../../static/img/8.ef089d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jpg/8.svg
// module id = ZLR8
// module chunks = 1